import { useLocation } from "react-router-dom";

export interface MainNavActiveState {
  readonly isHomeActive: boolean;
  readonly isLoansActive: boolean;
}

export const useMainNavActiveState = (): MainNavActiveState => {
  const { pathname } = useLocation();

  return {
    isHomeActive: pathname === "/home",
    isLoansActive: pathname === "/my-loans",
  };
};
